/*
 * R3.9 (client, deck slide 7): "Can we have description be automatically opened
 * and then when you click any of the others drop downs it closes? That way they
 * won't all be opened at the same time".
 *
 * "Description opens by default" is NOT handled here — it is the block's own
 * `open_accordion` setting in templates/product.json, so the merchant keeps
 * control of which tab starts open. This file only enforces the second half:
 * one open at a time.
 *
 * The PDP tabs are native <details> elements, which have no built-in exclusive
 * behaviour (the HTML `name` attribute that provides it is not supported by
 * Safari at the version floor this theme targets, so it is done in JS).
 *
 * Listening for 'toggle' rather than clicking `summary` means keyboard opens
 * and any programmatic `details.open = true` are covered too. Guarding on
 * `details.open` stops the close-others pass from re-entering: setting
 * `open = false` fires 'toggle' again on each sibling, and without the guard
 * those events would run their own close pass.
 */
(function () {
  'use strict';

  function scope(details) {
    // Only coordinate tabs inside the same product info column, so a PDP with
    // accordions elsewhere on the page (or two products in a quick-add drawer)
    // never closes an unrelated one.
    return details.closest('.product__info-container') || document;
  }

  function onToggle(event) {
    const details = event.target;
    if (!details.open) return;

    scope(details)
      .querySelectorAll('.product__accordion > details[open]')
      .forEach(function (other) {
        if (other !== details) other.open = false;
      });
  }

  function bind(root) {
    (root || document)
      .querySelectorAll('.product__accordion > details')
      .forEach(function (details) {
        if (details.dataset.exclusiveBound) return;
        details.dataset.exclusiveBound = 'true';
        details.addEventListener('toggle', onToggle);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind(document);
    });
  } else {
    bind(document);
  }

  // Variant changes re-render the info column, and the theme editor re-renders
  // the section on every setting change — both replace the <details> nodes.
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    bind(event.target);
  });

  // product-info.js swaps the info column markup on variant change without
  // firing a section event, so re-bind when that subtree is replaced.
  const container = document.querySelector('.product__info-container');
  if (container && 'MutationObserver' in window) {
    new MutationObserver(function () {
      bind(container);
    }).observe(container, { childList: true, subtree: true });
  }
})();
